import { render, staticRenderFns } from "./Shipping.vue?vue&type=template&id=fffa97bc&scoped=true&"
import script from "./Shipping.vue?vue&type=script&lang=js&"
export * from "./Shipping.vue?vue&type=script&lang=js&"
import style0 from "./Shipping.vue?vue&type=style&index=0&id=fffa97bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fffa97bc",
  null
  
)

export default component.exports